import CantileverButton from 'components/CantileverButton'
import styled from 'styled-components'

export const FilterHeaderButton = styled(CantileverButton)`
  padding: 0.25rem;
  margin-bottom: 0.25rem;
`
